import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

// `path` values the API uses for advisory card problems. Anything else is an unexpected failure,
// whose raw message we do not surface to the customer.
const CARD_WARNING_PATHS = ['invalid_card', 'no_card_on_file'];

function SubscriptionActionAlert({ actionError }) {
  if (!actionError) {
    return null;
  }

  if (!CARD_WARNING_PATHS.includes(actionError.path)) {
    return (
      <div
        role="alert"
        className="rounded-lg border border-red-200 bg-red-50 p-4"
      >
        <h4 className="mb-1 font-medium text-red-900">
          We couldn&apos;t complete that change
        </h4>
        <p className="text-red-800 text-sm">
          Your plan hasn&apos;t been changed and you haven&apos;t been charged.
          Please try again, or contact us if this keeps happening.
        </p>
      </div>
    );
  }

  return (
    <div
      role="alert"
      className="rounded-lg border-2 border-rccallouts-warning bg-amber-50 p-4"
    >
      <div className="flex items-start gap-3">
        <ExclamationTriangleIcon
          aria-hidden="true"
          className="mt-0.5 size-6 shrink-0 text-rccallouts-warning"
        />
        <div>
          <h4 className="mb-1 font-semibold text-amber-900">
            Check your payment method
          </h4>
          <p className="text-amber-900 text-sm">
            {actionError.message}{' '}
            <NavLink
              to="/payment-methods"
              className="font-semibold text-amber-900 underline"
            >
              Update it here
            </NavLink>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

SubscriptionActionAlert.propTypes = {
  actionError: PropTypes.object,
};

export default SubscriptionActionAlert;
